import {createAction} from 'redux-actions'

const PREFIX = 'entities'
const action = name => createAction(`${PREFIX}/${name}`)

export const update = action('UPDATE')
export const replace = action('REPLACE')
export const remove = action('REMOVE')
